export const compare = (x: string, y: string) => {
  return x.localeCompare(y);
};
